/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "model": {
            "nested": {
              "ReturnItem": {
                "fields": {
                  "trackingNumber": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "productName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "returnAuthorizationId": {
                    "type": "int32",
                    "id": 3,
                    "rule": "optional"
                  },
                  "receptionStatus": {
                    "type": "squareup.solidshop.model.ReturnItem.ReceptionStatus",
                    "id": 4,
                    "rule": "optional"
                  },
                  "trackingUrl": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "ReceptionStatus": {
                    "values": {
                      "GIVEN_TO_CUSTOMER": 1,
                      "LOST_IN_TRANSIT": 2,
                      "SHIPPED_WRONG_ITEM": 3,
                      "SHORT_SHIPPED": 4,
                      "IN_TRANSIT": 5,
                      "RECEIVED": 6,
                      "EXPIRED": 7,
                      "UNEXCHANGED": 8,
                      "CANCELLED": 9,
                      "AWAITING": 10
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.solidshop?.nested?.model?.nested?.ReturnItem && !$root.nested?.squareup?.nested?.solidshop?.nested?.model?.nested?.ReturnItem?.nested?.ReceptionStatus) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE ReturnItem @ squareup/solidshop/model/return_item.proto at 8:1
 */
export const ReturnItem = $root.lookupType('squareup.solidshop.model.ReturnItem');
fixType(ReturnItem);
Builder.createAndAttachToType(ReturnItem);
/**
 * SOURCE ReceptionStatus @ squareup/solidshop/model/return_item.proto at 9:5
 */
ReturnItem.ReceptionStatus = $root.lookupEnum('squareup.solidshop.model.ReturnItem.ReceptionStatus').values;
